module.exports = __webpack_public_path__ + "static/img/4.e2c4b2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/4.png
// module id = LDp3
// module chunks = 0